import { Domain } from 'features/inventory/types/domain'

export const isRefreshControlledByYb = ({
  overriddenByYieldbird,
  pubAdsServiceRefresh,
}: {
  overriddenByYieldbird?: Domain['overriddenByYieldbird']
  pubAdsServiceRefresh?: Domain['pubAdsServiceRefresh']
}): boolean => pubAdsServiceRefresh === 'controlledByYieldbird' || !!overriddenByYieldbird
